import axios from 'axios'

import { useClient } from '@monorepo/app_module'
import { IGood, IVendor, VendorIdType } from '@monorepo/interfaces'

type FetchOffersOptionsType = {
  crosses?: boolean
  stockOnly?: boolean
  providerName?: string
  vendor?: number
}

export function useApi() {
  const client = useClient()

  const api = {
    async findByQuery(
      brandName: string,
      number: string,
      options: FetchOffersOptionsType = {}
    ) {
      const params = { brandName, number, ...options }
      const { data } = await client.get<IGood[]>('/v2/search/findByQuery', {
        params,
      })

      return data
    },

    fetchSuggestions(
      number: string,
      options?: { strict?: boolean; useFTS?: boolean; vendor?: VendorIdType }
    ) {
      const source = axios.CancelToken.source()

      const promise = client
        .get<IGood[]>('/search/goods', {
          cancelToken: source.token,
          params: { ...options, number },
        })
        .then((response) => response.data)

      return Object.assign(promise, {
        cancel: () => {
          source.cancel('Query was cancelled by React Query')
        },
      })
    },

    async findGoodsBy(
      criteria: {
        number: string
      },
      options?: {
        strict?: boolean
      }
    ) {
      const { data } = await client.get<IGood[]>('/search/goods', {
        params: { ...criteria, ...options },
      })
      return data
    },

    async fetchRemoteVendors() {
      const { data } = await client.get<IVendor[]>('/vendor/getRemoteVendors')
      return data
    },

    updateRating: (good: IGood) => {
      return client
        .post(`/v2/search/select_suggestion/${good.id}`)
        .then((response) => response.data)
    },
  }

  return api
}
